import { useMemo } from "react";
import { AsyncSelectOption } from "../../../../components/AsyncSelect";
import FilterBuilder from "../../../../components/filter/FilterBuilder";
import { FilterRecord } from "../../../../components/filter/filter-constant";
import { useActiveComponentCountController } from "../../../../components/filter/use-ActiveComponentCountController";
import { useDebounce } from "../../../../hooks/use-debounce";
import { useProviderListV2 } from "../../../../queries/use-provider-list-v2";
import { DEF_PAGINATION, getXtenantId } from "../../../../utils/utils";
import { NEW_DATE_RANGE_FOR_CLAIMS_TYPE } from "./claims/claims-constants";

interface SuperBillFilterProps {
  filters: SuperBillFilterData;
  setSuperBillFilters: (superBillFilters: SuperBillFilterData) => void;
}

export type SuperBillFilterData = {
  archive?: boolean;
  patient_Name?: { value: string; label: string };
  // visit_Id?: string;
  provider_Name?: { value: string; label: string };
  bill_Status?: { value: string; label: string };
  date_range: undefined;
  startDate: undefined;
  endDate: undefined;
};

const SuperBillFilter = ({
  filters,
  setSuperBillFilters,
}: SuperBillFilterProps) => {
  const activeFilterCount = useActiveComponentCountController(filters);

  const [searchKey, setSearchKey] = useDebounce<string>("");
  const { data: providersList } = useProviderListV2({
    status: true,
    pagination: DEF_PAGINATION,
    searchString: searchKey,
    xTENANTID: getXtenantId(),
  });

  const providerOptions: AsyncSelectOption[] = useMemo(() => {
    return (
      providersList?.data?.content?.map((it) => ({
        value: it?.uuid,
        label: it?.name,
      })) ?? []
    );
  }, [providersList?.data?.content]);

  const billStatusOptions = [
    { value: "PAID", label: "Paid" },
    { value: "PENDING", label: "Pending" },
    { value: "PARTIALLY_PAID", label: "Partially Paid" },
    { value: "OVERDUE", label: "Overdue" },
    { value: "CANCELLED", label: "Canceled" },
  ];

  const filtersProvider: FilterRecord = {
    // super_id: {
    //   type: "text",
    //   label: "Super ID",
    //   placeholder: "Enter Super ID",
    // },
    provider_Name: {
      type: "select",
      label: "Provider",
      options: providerOptions,
      placeholder: "Search Provider",
      onSearch: (value) => setSearchKey(value),
    },
    bill_Status: {
      type: "select",
      label: "Bill Status",
      options: billStatusOptions,
      placeholder: "Select Bill Status",
    },
    date_range: {
      type: "date_range_preset",
      label: "Date Range",
      childKeys: ["date_range", "startDate", "endDate"],
      options: NEW_DATE_RANGE_FOR_CLAIMS_TYPE,
    },
  };

  return (
    <FilterBuilder
      filters={filtersProvider}
      onApply={(v) => setSuperBillFilters(v)}
      prefillValues={filters}
      activeFilterCount={activeFilterCount}
      h="11rem"
    />
  );
};

export default SuperBillFilter;
